/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Button } from "@mui/material";
import Config from "data/config";
import { Logger } from "cms/utils/log/logger";

const WelcomeHeaderBar = () => {
    
    // const url = new URL(window.location.href)
    // const domain = url.hostname

    let login_base_url = `${Config.API_BASEURL}${Config.LOGIN_URL}`;

    const redirect = encodeURI(Config.SIMPLICITY_AUTH_REDIRECT);
    let login_url = `${login_base_url}?redirectUri=${redirect}`;
    Logger.debug(`Login URL: ${login_url}`);
    // Logger.flush()

    const loginHandler = () => {
        // Send to Log in Url
        window.location.href = login_url;
    };

    return (
        <div
            style={{
                // backgroundColor: 'rgba(28,243,213,1)',
                top: 0,
                // backgroundColor: '#06b6d4',
                backgroundColor: "#FFFFFFFF",
                borderBottom: "1px solid #C0C0C0",
                position: "sticky",
            }}
        >
            <div
                style={{
                    width: "100hw",
                    padding: "8px",
                    display: "flex",
                    flexDirection: "row-reverse",
                }}
            >
                <Button variant='contained' color='primary' onClick={() => loginHandler()}>
                    Sign In
                </Button>
            </div>
        </div>
    );
};
export default WelcomeHeaderBar;
